import React from 'react';
import { Box, TextField } from '@mui/material';
import * as yup from 'yup';

// Shared by the create modal (`buyerContacts[]`) and the add-buyer dialog
// (POST /{id}/agents takes the same shape as one buyerContacts entry).
export const EMPTY_CONTACT = { name: '', title: '', persona: '', email: '' };

export const buyerContactSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required('Name is required'),
  title: yup
    .string()
    .trim()
    .required('Title is required'),
  persona: yup
    .string()
    .trim()
    .required('Persona is required'),
  email: yup
    .string()
    .trim()
    .email('Enter a valid email'),
});

// `email` is optional — omitted so the backend synthesizes one.
export const toBuyerContactPayload = (contact) => ({
  name: contact.name.trim(),
  title: contact.title.trim(),
  persona: contact.persona.trim(),
  ...(contact.email?.trim() ? { email: contact.email.trim() } : {}),
});

const BuyerContactFields = ({ contact, onChange, errorFor }) => (
  <>
    <Box
      display={'grid'}
      gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr 1fr' }}
      gap={1.5}
    >
      <TextField
        size="small"
        label="Name *"
        value={contact.name}
        onChange={(e) => onChange('name', e.target.value)}
        error={Boolean(errorFor('name'))}
        helperText={errorFor('name')}
      />
      <TextField
        size="small"
        label="Title *"
        placeholder="CTO"
        value={contact.title}
        onChange={(e) => onChange('title', e.target.value)}
        error={Boolean(errorFor('title'))}
        helperText={errorFor('title')}
      />
      <TextField
        size="small"
        label="Email"
        value={contact.email}
        onChange={(e) => onChange('email', e.target.value)}
        error={Boolean(errorFor('email'))}
        helperText={errorFor('email') || 'Optional — generated if left blank'}
      />
    </Box>
    <TextField
      size="small"
      fullWidth
      multiline
      minRows={2}
      label="Persona *"
      placeholder="skeptical, data-driven"
      value={contact.persona}
      onChange={(e) => onChange('persona', e.target.value)}
      error={Boolean(errorFor('persona'))}
      helperText={
        errorFor('persona') || 'Their motivations and stance in the deal'
      }
      sx={{ mt: 1.5 }}
    />
  </>
);

export default BuyerContactFields;
